import React from "react";
import {FieldProps} from "../List";

export default ({value}: FieldProps) => {
    return `${value.lastname} ${value.firstname}`;
}